import { useEffect, useState } from 'react';
import type { InvoiceItem } from './invoice-list.types';

const getUpdatedList = (list: InvoiceItem[], page: number, size: number) => {
  const start = (page - 1) * size;
  return list.slice(start, start + size);
};

export const ITEMS_PER_PAGE = [10, 15, 20];

export const usePaginatedInvoiceList = (
  list: InvoiceItem[],
): {
  currentPage: number;
  list: InvoiceItem[];
  pageSize: number;
  setCurrentPage: (page: number) => void;
  setPageSize: (size: number) => void;
} => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(ITEMS_PER_PAGE[0]);
  const [paginatedList, setPaginatedList] = useState(getUpdatedList(list, currentPage, pageSize));

  useEffect(() => {
    setPaginatedList(getUpdatedList(list, currentPage, pageSize));
  }, [currentPage, pageSize, list]);

  return {
    currentPage,
    pageSize,
    list: paginatedList,
    setCurrentPage,
    setPageSize,
  };
};
